import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIElementsModule } from '@flexus/ui-elements';
import { FLXAPInstallationSummaryComponent } from './ap-installation-summary.component';

@NgModule({
	declarations: [FLXAPInstallationSummaryComponent],
	imports: [CommonModule, UIElementsModule],
	exports: [FLXAPInstallationSummaryComponent]
})
export class APInstallationSummaryModule {}
